module.exports = __webpack_public_path__ + "img/crown.44a6c97b.svg";